module.exports = __webpack_public_path__ + "static/dataart.66e96fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/dataart.png
// module id = 621
// module chunks = 35783957827783